import styled from "styled-components";
import { device } from "../../../helpers/breakpoints";

export const SignInContainer = styled.main`
  height: 100vh;
  background-color: #FAFAFA;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    display: none;
  }

  @media ${device.tablet} {
    flex-direction: column;

    img.top-logo {
      display: block;
      height: 1.54rem;
      width: 4.709rem;
      position: absolute;
      left: 8%;
      top: 8%;
    }
  }

  @media ${device.mobile} {
    img.top-logo {
      left: 8%;
      top: 3%;
    }
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;

  .inner-logo {
    display: block;
    margin-bottom: 2.125rem;
    height: 2.114rem;
    width: 6.464rem;
  }

  @media ${device.tablet} {
    display: none;
  }
`;

// background-color: ${(props) => props.theme.colors.compassWhiteSub};

export const FormCard = styled.div`
  border: 0.031rem solid #f1f2f5;
  border-radius: 0.25rem;
  background-color: #FEFFFE;
  padding: 3em 6em;
  width: 32rem;
  max-width: 32rem;

  div:nth-child(1) {
    padding-bottom: 0.625rem;

    & > p {
      font-size: 0.75rem;
      line-height: 1.25rem;
      text-align: center;
      padding-top: 0.625rem;
      color: "#000000";
    }

    & > h3 {
      font-weight: 600;
      font-size: 1rem;
      line-height: 1.5rem;
      text-align: center;
      color: "#000000";
    }
  }

  @media ${device.tablet} {
    width: 100%;
    position: relative;
    transform: translateY(1.875rem);
    padding: 1em;
  }
`;
